import React from 'react';
import { GameData } from '../types';
import GameCard from './GameCard';
import { GameListSkeleton } from './skeletons';

interface GameListProps {
  games: GameData[];
  loading?: boolean;
  error?: string | null;
  className?: string;
}

const GameList: React.FC<GameListProps> = ({ games, loading, error, className }) => {
  if (loading) {
    return <GameListSkeleton count={12} />;
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="text-red-500 text-lg font-semibold mb-2">Erreur</div>
        <div className="text-gray-600 dark:text-gray-400">{error}</div>
      </div>
    );
  }

  if (games.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-500 dark:text-gray-400 text-lg">Aucun jeu trouvé</div>
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ${className || ''}`}>
      {games.map((game, index) => (
        <GameCard key={`${game.url}-${index}`} game={game} />
      ))}
    </div>
  );
};

export default GameList;
